import React from "react"
import { useValueRef } from "@/hooks/useValueRef";

import { useDropdown, DropdownItems, DropdownItem } from "../UiBlocks/components/Dropdown";
import { createPortal } from "react-dom";
import { Zone } from "./types";
import { ArticleSchema } from "@roc-digital/mxm-base/src/data";
import { isStaticArticle } from "./utils";

interface ContextMenuProps {
  onAction: (action: 'pin' | 'remove') => void
}

export function useContextMenu(props: ContextMenuProps) {
  const propsRef = useValueRef(props);
  const [contextItems, setContextItems] = React.useState<DropdownItems>([
    {id: 'pin', label: 'Pin', disabled: false},
    {id: 'remove', label: 'Remove from zone', disabled: false},
  ]);

  // const contextItems = React.useMemo<DropdownItems>(() => {
  //   return [
  //     {id: 'pin', label: 'Pin', disabled: false},
  //     {id: 'remove', label: 'Remove from zone', disabled: false},
  //     // '-',
  //     // {id: 'edit', label: 'Edit Article', disabled: !props.hasElement},
  //   ];
  // }, []);


  const dropdown = useDropdown({
    items: contextItems,
    onActivateItem: (itemId: string) => {
      propsRef.current.onAction(itemId as any);
    }
  });

  const rootElement = React.useMemo(() => {
    let e = document.getElementById('view-dropdown-container');
    if(e) return e;
    e = document.createElement('div');
    e.id = 'view-dropdown-container';
    document.body.appendChild(e);
    return e;
  }, []);

  const jsx = createPortal(dropdown.jsx, rootElement);

  const open = React.useCallback((event: any, zone: Zone, articleId: string) => {
    setContextItems(createMenu(zone, articleId));
    dropdown.open(event);
  }, [dropdown.open]);

  return {
    jsx,
    open,
    close: dropdown.close,
  };
}

function createMenu(zone: Zone, articleId: string): DropdownItems {
  const items: DropdownItems = [
    {id: 'pin', label: 'Pin', disabled: false},
  ];

  if(isStaticArticle(zone, articleId) === false) {
    items.push({id: 'remove', label: 'Remove article from zone tags', disabled: false})
  }

  return items;
}
